import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getReasonUsoAvailableColumns } from './api';

export const path = '/reason-uso/list';

const PageReasonUso: React.FC = (props) => {
  const ReasonUso = Loadable.Map({
    loader: {
      page: () => import('./page'),
      columns: getReasonUsoAvailableColumns,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <ReasonUso {...props} />;
};

export default PageReasonUso;
